var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ border_bottom1px: _vm.borderBottom }},[_c('van-field',{attrs:{"placeholder":_vm.placeholder},on:{"blur":_vm.blur},model:{value:(_vm.text),callback:function ($$v) {_vm.text=$$v},expression:"text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }